import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "2ffa7c31-7de4-461e-a9f6-e5ce6f93a941", content: "Density increases", options: {} },
  { id: "28dfcc68-6285-4de1-9890-6ab805946064", content: "Density decreases", options: {} },
  { id: "5da8d18e-19a8-49fb-8dd6-e0d176a9222f", content: "Pressure decreases", options: {} },
  { id: "b7d1ad9c-413c-42ab-8a37-877a020a7722", content: "Molecular mass increases", options: {} },
  { id: "cbf9a5ee-158f-4a4c-a60f-76fb65c9b4d1", content: "Pressure increases", options: {} },
  { id: "a496d7c4-bd6f-40b1-9d46-269866d3f582", content: "Temperature decreases", options: {} },
  { id: "69ea3185-c203-4af5-a1ef-8e0aeff6cebd", content: "Molecular mass decreases", options: {} },
  { id: "7222b889-72c2-4f7d-882c-d346d184503e", content: "Temperature increases", options: {} },
];

export const task: Task = {
  id: "e9ee75cc-a3b5-4ad6-8c0a-6026c6a396c4",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["69ea3185-c203-4af5-a1ef-8e0aeff6cebd", "7222b889-72c2-4f7d-882c-d346d184503e"],
};
